import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Col, Container, Row } from 'reactstrap';
import { TopComponent, TopComponentSize } from '../../components/TopComponent';
import { HeaderTitle } from '../../components/HeaderTitle';
import { PlaylistsSharingGetAccessButton } from '../../playlistsSharing/PlaylistsSharingGetAccessButton';
import { MainNavbar } from '../../../../layouts/MainNavbar';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksLinkfireAlternativePageTop: React.FC = () => {
  const intl = useIntl();

  return (
    <TopComponent size={TopComponentSize.FullWidth} navbarComponent={<MainNavbar />}>
      <Container className="pb-lg-5">
        <Row className="pt-xl-3">
          <Col xs={12} lg={6} className="text-lg-start text-center d-flex flex-column">
            <HeaderTitle>
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.title',
                defaultMessage: 'What makes Music24 a great Linkfire alternative'
              })}
            </HeaderTitle>
            <p className="lead">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.description',
                defaultMessage:
                  'Looking for the best Linkfire alternative? Music24 is a modern platform for connecting fans to your music in a simple and smart way 🎧'
              })}
            </p>
            <div className="justify-content-lg-start">
              <PlaylistsSharingGetAccessButton className="align-items-lg-start" source="LinkFireAlternative Page Top">
                <Button
                  href="https://mreazi.fym.fm/legalize"
                  color="primary"
                  size="xl"
                  className="align-items-lg-start btn-shadow-primary mt-3"
                >
                  {intl.formatMessage({
                    id: 'sml.web.smart-links.see-demo',
                    defaultMessage: 'See Demo'
                  })}
                </Button>
              </PlaylistsSharingGetAccessButton>
            </div>
          </Col>
          <Col xs={12} lg={6} className="px-0 justify-content-center d-flex flex-column top-promo-img-col">
            <img
              alt="Mr Eazi Screenshot SmartLinks App"
              src={nextAsset('images/smartLinks/home/eazi.png')}
              className="top-promo-img"
            />
          </Col>
        </Row>
      </Container>
    </TopComponent>
  );
};
